import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters, PotentialCompetitors } from '@sales-app/context/workspace/workspace.type'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputMultiSelect } from '@/components/Input/InputMultiSelect'

type Props = {
  currentFilters: HomeFilters
}

export const CompetitorSelection: FC<Props> = ({ currentFilters }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()

  const initialPotentialCompetitors = currentFilters.potentialCompetitors?.map((potentialCompetitor) => {
    return { label: potentialCompetitor, value: potentialCompetitor }
  })
  const options = Object.values(PotentialCompetitors).map((potentialCompetitor) => {
    return { label: potentialCompetitor, value: potentialCompetitor }
  })

  const onChange = (values: { potentialCompetitors: { value: PotentialCompetitors }[] | undefined }) => {
    if (values.potentialCompetitors) {
      if (values.potentialCompetitors.length > 0) {
        WorkspaceDispatch(
          WorkspaceAction.updateFilters({ potentialCompetitors: values.potentialCompetitors.map((v) => v.value) }),
        )
      } else {
        WorkspaceDispatch(WorkspaceAction.updateFilters({ potentialCompetitors: undefined }))
      }
    }
  }

  return (
    <Formik
      initialValues={{
        potentialCompetitors: initialPotentialCompetitors,
      }}
      onSubmit={onChange}
    >
      {({ submitForm }) => {
        return (
          <Form className="flex w-1/2 flex-row flex-wrap">
            <InputMultiSelect
              className="w-full"
              id="potentialCompetitors"
              name="potentialCompetitors"
              onChange={submitForm}
              options={options}
              variant="clean"
            ></InputMultiSelect>
          </Form>
        )
      }}
    </Formik>
  )
}
